import { isArray, trim } from 'lodash'

export default {
  data () {
    return {
      dirty: false
    }
  },
  computed: {
    $v () {
      // eslint-disable-next-line no-unused-expressions
      this.dirty
      let $valid = true
      const keys = Object.keys(this.rules).filter(key => key[0] !== '$')
      const res = keys.reduce((obj, key) => {
        let result = {
          isValid: true,
          status: '',
          msg: null
        }
        if (isArray(this.rules[key])) {
          const validations = this.rules[key]
          for (let i = 0; i < validations.length; i++) {
            const validation = validations[i]
            if ((this.form[key] != null || this.dirty !== false) && !validation(trim(this.form[key]))) {
              $valid = false
              result.isValid = false
              result.status = 'is-danger'
              result.msg = `${key} ${validation.name} validation fail`
              break
            }
          }
          obj[key] = result
        } else {
          for (const [k, val] of Object.entries(this.rules[key])) {
            let result = {
              status: null,
              msg: null
            }
            if (!obj[key]) obj[key] = {}
            obj[key][k] = result
            for (let i = 0; i < val.length; i++) {
              const validation = val[i]
              if ((this.form[key][k] != null || this.dirty !== false) && !validation(trim(this.form[key][k]))) {
                $valid = false
                result.isValid = false
                result.status = 'is-danger'
                result.msg = `${k} ${validation.name} validation fail`
                break
              }
            }
          }
          return obj
        }
        return obj
      }, {})
      const $touch = () => {
        this.dirty = true
      }
      return {
        ...res,
        $valid,
        $touch
      }
    }
  }
}
